import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ThreeHundredPointInspectionInfo from "./component";
import { fetchRwcCmsContent } from "../rwc-landing-page/actions";

const mapStateToProps = ({
    roadWorthyCertificate: {
        cmsContent
    }
}) => ({
    cmsContent
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchRwcCmsContentConnect: fetchRwcCmsContent
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ThreeHundredPointInspectionInfo);
